import LeftPanel, { hideLeftPanel } from 'common/components/leftPanel'
import { useAppDispatch } from 'common/hooks/redux'

import ElementsList from './ElementsList'

const LeftSection = () => {
  const dispatch = useAppDispatch()
  return (
    <LeftPanel onOutsideClick={() => dispatch(hideLeftPanel())}>
      <ElementsList />
    </LeftPanel>
  )
}

export default LeftSection
